import { ApiProperty } from '../../codegen';

/**
 * Game action from the client.
 * May contain surrender: true or game-specific fields (col, row, etc.).
 */
export interface IGameAction {
  surrender?: boolean;
  [key: string]: unknown;
}

export class GameActionResult {
  @ApiProperty()
  newState?: unknown;

  @ApiProperty()
  nextPlayerSlot?: number;

  @ApiProperty()
  isGameOver: boolean;

  @ApiProperty()
  winner?: number;

  @ApiProperty()
  results?: Record<string, unknown>;
}

export interface IGameEngine<TState = unknown, TAction = unknown> {
  readonly gameId: number;
  readonly engineName: string;
  initialize(playerSlots: number[]): TState;
  processAction(
    state: TState,
    playerSlot: number,
    action: TAction,
  ): GameActionResult;
  isPlayerTurn(state: TState, playerSlot: number): boolean;
  getCurrentPlayerSlot(state: TState): number;
  /** Convert state to client format (e.g. FEN → board + castling). If omitted, state is sent to the client as-is. */
  toClientState?(state: TState): unknown;
  /** Prepare server-side data for persistence in match results. */
  getPersistentMatchResults?(
    state: TState,
  ): Record<string, unknown> | undefined;
}
